import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.095 3.143a.89.89 0 0 1 .857-.857.87.87 0 0 1 .905.857v.9a8.57 8.57 0 0 1 7.714 8.529v1.559a8.85 8.85 0 0 0 2.587 6.246l.145.145a2.3 2.3 0 0 1 .7 1.677 2.37 2.37 0 0 1-2.373 2.373H6.372A2.37 2.37 0 0 1 4 22.2a2.3 2.3 0 0 1 .695-1.677l.147-.145a8.85 8.85 0 0 0 2.586-6.246v-1.56a8.57 8.57 0 0 1 7.714-8.529Zm.857 2.571a6.89 6.89 0 0 0-6.857 6.857v1.559a10.5 10.5 0 0 1-3.04 7.457l-.147.145a.72.72 0 0 0-.241.466.7.7 0 0 0 .706.659h19.254a.66.66 0 0 0 .659-.659.67.67 0 0 0-.193-.466l-.145-.145a10.53 10.53 0 0 1-3.091-7.457v-1.558a6.867 6.867 0 0 0-6.905-6.857Zm0 22.286a1.74 1.74 0 0 0 1.666-1.141.82.82 0 0 1 1.093-.525.863.863 0 0 1 .525 1.093 3.432 3.432 0 0 1-6.471 0 .863.863 0 0 1 .525-1.093.82.82 0 0 1 1.093.525A1.7 1.7 0 0 0 15.952 28"
    }, null, -1)
  ])))
}
export default { render: render }